import './SectionComponent.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState } from 'react';
import sendEmail from '../../sendEmail';

function ContactSection() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        try {
            await sendEmail({
                time: new Date().toISOString(),
                from_name: name,
                reply_to: email,
                message: message,
                to_email: 'nsaenz426@gmail.com'
            });
            setStatus('sent');
            setName(''); setEmail(''); setMessage('');
        } catch (err) {
            console.error('sendEmail error', err);
            setStatus('error');
        }
    };

    return (
        <div id="contacto" className="App-contact_section anchor_tags">
            <h2>Contacto</h2>
            <form onSubmit={handleSubmit}>
                <TextField value={name} onChange={(e)=>setName(e.target.value)} type="text" label="Nombre" margin="dense"/>
                <TextField value={email} onChange={(e)=>setEmail(e.target.value)} type="email" label="Email" margin="dense"/>
                <TextField
                    value={message}
                    onChange={(e)=>setMessage(e.target.value)}
                    label="Mensaje"
                    multiline
                    rows={6}
                    margin="dense"
                />
                <Button type="submit" variant="contained" disabled={status==='sending'}>Enviar</Button>
                {status === 'sending' && <p>Enviando...</p>}
                {status === 'sent' && <p style={{color:'green'}}>Mensaje enviado. Gracias!</p>}
                {status === 'error' && <p style={{color:'red'}}>Error enviando el mensaje. Intenta más tarde.</p>}
            </form>
        </div>
    );
}

export default ContactSection;